(window.YPMegaMenu = function ($, Behaviors) {
    "use strict";

    const module = {};

    const YPMegaMenu = {
        'adjustHeight': () => {
            const parents = $('.ypMegaMenuHolder');

            parents.each(function (index, parentEl) {
                let items = $(this).find('ul.sub-menu ul.sub-menu');
                let heights = [];
                parentEl = $(parentEl);

                if (window.innerWidth < 1050) {
                    parentEl.css('height', 'auto');
                    return;
                }

                items.each(function (index, item) {
                    item = $(item);
                    const fixedItemHeight = parseFloat($(item).outerHeight()) + parseFloat(parentEl.css('padding-top')) + parseFloat(parentEl.css('padding-bottom'));
                    heights.push(fixedItemHeight);
                });

                parentEl.css('height', Math.max(...heights));
            });
        },

        'megaMenuBtn': () => {
            const megaMenuBtn = $('[ypmegamenu-btn]');

            megaMenuBtn.on('click', e => {
                let {target} = e;
                target = $(target);
                target.toggleClass('active');
                target.next().slideToggle();
            });
        },

        'megaMenuMobile': () => {
            const menu = $('.ypMegaMenu');

            menu.on('click', '.yp-menu-toggle', function (e) {
                if (window.innerWidth > 1050) {
                    return;
                }

                $(this).toggleClass('active');
                $(this).parent().next().stop().slideToggle();
            });

            // const menuHolder = $('.ypMenuHolder');
            $('.ypMenuHolder').css('max-height', window.innerHeight - parseFloat($('#ypHeader').innerHeight()) + 'px'); //fix height
        },

        'cloneSingUpBtn' : () => {
            const singUpBtn = $('#ypHeader .YPButton');
            if (singUpBtn.length) {
                $('.ypMenuHolder').append(singUpBtn.clone(true));
            }
        }
    }

    // Behaviors.
    module.YPMegaMenu = YPMegaMenu;

    let to = true,
        throttle = function (func, delay) {
            if (to) {
                window.clearTimeout(to);
            }
            to = window.setTimeout(func, delay);
        };

    $(window).on('resize', function () {
        throttle(function () {
            YPMegaMenu.adjustHeight();
            YPMegaMenu.megaMenuMobile();
        }, 250);
    });

    $(document).on('ready', () => {
        YPMegaMenu.megaMenuBtn();
        YPMegaMenu.adjustHeight();
        YPMegaMenu.megaMenuMobile();
        YPMegaMenu.cloneSingUpBtn();
    });

    return module;

}(window.jQuery, window.Behaviors));